import { Component, OnInit, signal } from '@angular/core';
import { IntegradorService } from '../../../../services/integrador.service';
import { ToastService } from '../../../../services/toast.service';
import { Instancia } from '../../../../types/Instancia.type';
import { Pesagem } from '../../../../types/Pesagem.type';

@Component({
  selector: 'app-pesagem',
  templateUrl: './pesagem.component.html',
  styleUrl: './pesagem.component.css'
})
export class PesagemComponent implements OnInit {

  pesagens: Pesagem[] = [];
  loading: boolean = false
  loadingSincronizar: boolean = false;
  pesagemSelecionada: Pesagem = {} as Pesagem;
  visible: boolean = false;

  count = signal(10); // Inicializa o contador com 10
  intervalId: any;

  iniciaContador() {
    this.intervalId = setInterval(() => {
      if (this.count() > 0) {
        this.count.set(this.count() - 1);
      } else {
        this.getPesagens();
        this.count.set(10); // Reinicia o contador
      }
    }, 1000); // Atualiza a cada segundo
  }

  status: any[] = [ {name: 'Integrado', value: 'Integrado' }
                  , {name: 'Enviando ao PIMS', value: 'Enviando ao PIMS'}
                  , {name: 'Aguardando Pesagem', value: 'Aguardando Pesagem'}
                  , {name: 'Enviando ao ERP', value: 'Enviando ao ERP'}
                  , {name: 'Erro', value: 'Erro'}
                  , {name: 'Gerando Certificado', value: 'Gerando Certificado'}
                  , {name: 'Cancelado', value: 'Cancelado'}
                ]

  instancias: Instancia[] = [{id: 'VALE', nome: 'VALE'}, {id: 'UCP', nome: 'UCP'}, {id: 'UVP', nome: 'UVP'} ]

  constructor(private integradorService: IntegradorService, private toastService: ToastService) {}

  ngOnInit(): void {
    this.getPesagens()
  }

  filter(event: Event){
    console.log(event)
  }

  sincronizarOrdens(){
    this.loadingSincronizar = true
    this.integradorService.sincronizarPesagens().subscribe({
      next: (data) => {
        this.getPesagens();
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao sincronizar: " + error.error.message)
      },
      complete: () => {
        this.loadingSincronizar = false
      }
    })
  }

  getPesagens(){
    this.loading = true;

    this.integradorService.getPesagens().subscribe({
      next: (data) => {
        this.pesagens = data;
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar as informações: " + error.error.message)
        console.log(error)
      },
      complete: () => {
        this.loading = false
      }
    })
  }

  getStatus(status: string): string{

    let stt = '';

    switch(status){
      case "IT":
        stt = "Integrado";
        break;
      case "IP":
        stt = "Enviando ao PIMS";
        break;
      case "AP":
        stt = "Aguardando Pesagem";
        break;
      case "IE":
        stt = "Enviando ao ERP";
        break;
      case "ER":
        stt = "Erro";
        break;
    }

    return stt;

  }

  getSeverity(status: string): string {
    let stt = '';

    switch(status){
      case "Integrado":
        stt = "success";
        break;
      case "Erro":
        stt = "danger";
        break;
      default:
        stt = "info";
        break;
    }

    return stt;
  }

  getIcon(status: string): string {
    let stt = '';

    switch(status.toLowerCase()){
      case "integrado":
        stt = "pi pi-check";
        break;
      case "erro":
        stt = "pi pi-times";
        break;
      case "enviando ao pims":
        stt = "pi pi-arrow-down-left";
        break;
      case "aguardando pesagem":
        stt = "pi pi-history"
        break;
      case "enviando ao erp":
          stt = "pi pi-arrow-up-right";
          break;
      case "cancelado":
         stt = "pi pi-ban";
         break;
      case "gerando certificado":
        stt = "pi pi-file-o" ;
        break;
      case "pesando":
          stt = "pi pi-truck"
          break;
      default:
        stt = "pi pi-info";
        break;
    }

    return stt;
  }

  toInt(texto: string): number{

    return parseInt(texto);
  }

  exibirJson(pesagem: Pesagem){
    this.visible = true;
    this.pesagemSelecionada = pesagem;

    console.log(this.pesagemSelecionada)
  }


}
